(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Forms = Lfl.Forms || {};

    (function (Forms, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Forms, 'InputFocuser')) {
            return;
        }

        /*
         |===============================================================================================================
         | Class definition
         |===============================================================================================================
         */

        /**
         * Helps focus given input and override autofocus.
         *
         * @memberOf Lfl.Forms
         * @lends Lfl.Forms.InputFocuser
         * @constructor
         */
        Lfl.Forms.InputFocuser = function () {
            /*
             |-----------------------------------------------------------------------------------------------------------
             | Public methods
             |-----------------------------------------------------------------------------------------------------------
             */

            /**
             *
             * @param {jQuery} $controllingInput
             * @param {boolean} overrideAutofocus
             */
            this.focus = function($controllingInput, overrideAutofocus) {
                if (typeof overrideAutofocus === 'undefined') {
                    overrideAutofocus = false;
                }

                performFocusTheInput(overrideAutofocus, $controllingInput);
                if (overrideAutofocus) {
                    $(document).ready(function () {
                        // Yes, sadly the autofocus is hard to root out.
                        performFocusTheInput(overrideAutofocus, $controllingInput);
                    });
                }
            };

            /*
             |-----------------------------------------------------------------------------------------------------------
             | Private methods
             |-----------------------------------------------------------------------------------------------------------
             */
            function performFocusTheInput(overrideAutofocus, $input) {
                if (overrideAutofocus === true) {
                    // If an element has autofocus tag, it means that it is supposed to be autofocused. Only
                    // autofocus="autofocus" and autofocus are allowed, other ones (especially autofocus="false") are invalid.
                    //      See: https://stackoverflow.com/questions/4445765/html5-is-it-autofocus-autofocus-or-autofocus
                    var $autofocusedElements = $('[autofocus]');
                    $autofocusedElements.attr('autofocus', null);
                    // And since even though the autofocus gets removed, but the browser still remembers that it should be
                    // focused, we have to blur the elements which had the autofocus...
                    $autofocusedElements.blur();
                    $input.attr('autofocus', 'true');
                }
                $input.focus();
            }
        };
    }(Lfl.Forms, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
